import React from "react";
import { useI18n } from "../../i18n";
import { ArrowRight } from "lucide-react";

const CTA_IMG =
  "https://images.unsplash.com/photo-1574966739987-65e38db0f7ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nJTIwdGFibGUlMjBzZXR0aW5nfGVufDB8fHx8MTc3OTAwNDg0MXww&ixlib=rb-4.1.0&q=85";

export default function CTABanner() {
  const { t } = useI18n();
  return (
    <section className="px-4 md:px-6 lg:px-12 pb-20 md:pb-28" data-testid="cta-banner">
      <div className="relative max-w-7xl mx-auto rounded-[28px] overflow-hidden grain bg-brand-forest">
        <img
          src={CTA_IMG}
          alt="Fine dining table with wine glasses"
          className="absolute inset-0 w-full h-full object-cover opacity-25"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-forest via-brand-forest/85 to-brand-forest/50" />
        <div className="relative px-8 md:px-14 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-8">
            <p className="eyebrow !text-brand-terracotta reveal">{t("cta.eyebrow")}</p>
            <h2 className="display-h2 mt-4 text-brand-ivory reveal" data-delay="1" data-testid="cta-banner-title">
              {t("cta.title")}
            </h2>
            <p className="body-lg !text-brand-ivory/80 mt-5 max-w-xl reveal" data-delay="2">
              {t("cta.sub")}
            </p>
          </div>
          <div className="md:col-span-4 flex md:justify-end reveal" data-delay="3">
            <a href="#lead" data-testid="cta-banner-button" className="btn-accent">
              {t("cta.primary")} <ArrowRight size={16} strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
